import { render, staticRenderFns } from "./PageHeaderTabs.vue?vue&type=template&id=178ed120&scoped=true"
import script from "./PageHeaderTabs.vue?vue&type=script&lang=js"
export * from "./PageHeaderTabs.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderTabs.vue?vue&type=style&index=0&id=178ed120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ed120",
  null
  
)

export default component.exports